import React from "react";
import { SingleOrMultiSelectQuestion } from "schedule-v2/components/recorded-content/ExamCreation/modals/QuestionsModal/pages/QuestionDetails/components/HelperComponents/HelperComponents";
import {
  COLUMN_FIELD_TYPE_OPTIONS,
  CUSTOM_COLUMN_FORM_KEYS,
  SHORT_TEXT_MAX_LENGTH,
} from "../constants/CustomColumnFormField.constants";
import { composeValidators } from "utils/validations";
import { maxLength, requiredWithMessage } from "common/validate";

export const InputFieldTypeValues = ({ type }) => {
  switch (type) {
    case COLUMN_FIELD_TYPE_OPTIONS.single_select.value:
    case COLUMN_FIELD_TYPE_OPTIONS.multiple_select.value:
      return <SingleOrMultiSelectQuestion />;
    default:
      return null;
  }
};

export const SHORT_TEXT_VALIDATION = {
  [CUSTOM_COLUMN_FORM_KEYS.custom_value.key]: maxLength(
    SHORT_TEXT_MAX_LENGTH,
    `Custom value for short text type should be less than ${SHORT_TEXT_MAX_LENGTH} characters`
  ),
};

export const VALIDATORS = {
  [CUSTOM_COLUMN_FORM_KEYS.custom_value.key]: ({ fieldType }) =>
    composeValidators(
      requiredWithMessage("Please select custom value for older contacts"),
      fieldType === COLUMN_FIELD_TYPE_OPTIONS.short_text.value
        ? SHORT_TEXT_VALIDATION[CUSTOM_COLUMN_FORM_KEYS.custom_value.key]
        : () => {}
    ),
  [CUSTOM_COLUMN_FORM_KEYS.default_value.key]: ({ fieldType }) =>
    composeValidators(
      fieldType === COLUMN_FIELD_TYPE_OPTIONS.short_text.value
        ? SHORT_TEXT_VALIDATION[CUSTOM_COLUMN_FORM_KEYS.custom_value.key]
        : () => {}
    ),
};
